import type { GridSortDirection, GridSortModel } from "@mui/x-data-grid-pro"

const isGridSortDirection = (value: unknown): value is GridSortDirection =>
  value === "asc" || value === "desc"

const isSortModelItem = (
  value: unknown,
  allowedFields: Set<string>
): value is { field: string; sort: GridSortDirection } => {
  if (typeof value !== "object" || value === null) {
    return false
  }

  const record = value as Record<string, unknown>
  return (
    typeof record.field === "string" &&
    allowedFields.has(record.field) &&
    isGridSortDirection(record.sort)
  )
}

export const parseStoredSortModel = (
  raw: string,
  allowedFields: Set<string>,
  defaultSortModel: GridSortModel
): GridSortModel => {
  try {
    const parsed: unknown = JSON.parse(raw)
    if (!Array.isArray(parsed)) {
      return defaultSortModel
    }

    const validated = parsed.flatMap(item => {
      if (!isSortModelItem(item, allowedFields)) {
        return []
      }

      return [{ field: item.field, sort: item.sort }]
    })

    return validated.length > 0 ? validated : defaultSortModel
  } catch {
    return defaultSortModel
  }
}
